/**
 * Stage is object to handle canvas
 * @fileoverview This manage canvas
 *
 */

'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extension = _interopRequireDefault(require("../extensions/extension"));
var _GEHelper = require("../graphicEngine/GEHelper");
var _GEHandle = require("../graphicEngine/GEHandle");
var _PIXIAtlasManager = require("./pixi/atlas/PIXIAtlasManager");
/**
 * class for a canvas
 * @constructor
 */
Entry.Stage = /*#__PURE__*/function () {
  function Stage() {
    (0, _classCallCheck2["default"])(this, Stage);
    (0, _defineProperty2["default"])(this, "render", function stageRender() {
      if (Entry.stage.timer) {
        clearTimeout(Entry.stage.timer);
      }
      var time = _.now();
      Entry.stage.update();
      time = _.now() - time;
      Entry.stage.timer = setTimeout(stageRender, 16 - time % 16 + 16 * Math.floor(time / 16));
    });
    /** @type {Dictionary} */
    this.variables = {};
    this.objectContainers = [];
    this.selectedObjectContainer = null;

    /** @type {null|Entry.EntryObject} */
    this.selectedObject = null;
    this.isObjectClick = false;
    this._entitySelectable = true;

    /** @type {PIXI.Application | CreateJsApplication} */
    this._app = null;
    this.background = _GEHelper.GEHelper.newGraphic();
    this.background.graphics.beginFill('#ffffff').drawRect(-480, -240, 960, 480);
    this.variableContainer = _GEHelper.GEHelper.newContainer('variableContainer');
    this.dialogContainer = _GEHelper.GEHelper.newContainer('dialogContainer');
  }

  /**
   * initialize stage with canvas
   * @param {!Element} canvas for stage
   */
  return (0, _createClass2["default"])(Stage, [{
    key: "initStage",
    value: function initStage(canvas) {
      var _this = this;
      this._app = _GEHelper.GEHelper.newApp(canvas);
      this.canvas = this._app.stage;
      this.canvas.x = 960 / 1.5 / 2;
      this.canvas.y = 540 / 1.5 / 2;
      this.canvas.scaleX = this.canvas.scaleY = 2 / 1.5;
      this.canvas.addChild(this.background);
      this.canvas.addChild(this.variableContainer);
      this.canvas.addChild(this.dialogContainer);
      this.inputField = null;
      this.initCoordinator();
      this.initHandle();
      this.mouseCoordinate = {
        x: 0,
        y: 0
      };
      var _addEventListener = Entry.addEventListener.bind(Entry);
      if (Entry.isPhone()) {
        canvas.ontouchstart = function (e) {
          Entry.dispatchEvent('canvasClick', e);
          Entry.stage.isClick = true;
        };
        canvas.ontouchend = function (e) {
          Entry.stage.isClick = false;
          Entry.dispatchEvent('canvasClickCanceled', e);
        };
      } else {
        var downFunc = function downFunc(e) {
          Entry.dispatchEvent('canvasClick', e);
          if (e.which == 2) {
            console.log('mouse wheel click disabled');
            return;
          }
          Entry.stage.isClick = true;
        };
        canvas.onmousedown = downFunc;
        canvas.ontouchstart = downFunc;
        var upFunc = function upFunc(e) {
          Entry.stage.isClick = false;
          Entry.dispatchEvent('canvasClickCanceled', e);
        };
        canvas.onmouseup = upFunc;
        canvas.ontouchend = upFunc;
        $(document).click(function (_ref) {
          var id = _ref.target.id;
          _this.focused = id === 'entryCanvas';
        });
      }
      _addEventListener('canvasClick', function () {
        return Entry.stage.isObjectClick = false;
      });
      _addEventListener('loadComplete', this.sortZorder.bind(this));
      Entry.windowResized.attach(this, this.updateBoundRect.bind(this));
      var razyScroll = _.debounce(function () {
        Entry.windowResized.notify();
      }, 200);
      $(window).scroll(function () {
        window.requestAnimationFrame(razyScroll);
      });
      var moveFunc = function moveFunc(e) {
        e.preventDefault();
        var _Entry$Utils$convertM = Entry.Utils.convertMouseEvent(e),
          offsetY = _Entry$Utils$convertM.offsetY,
          offsetX = _Entry$Utils$convertM.offsetX,
          clientX = _Entry$Utils$convertM.clientX,
          clientY = _Entry$Utils$convertM.clientY;
        var roundRect = Entry.stage.getBoundRect();
        var x = offsetX || clientX && clientX - roundRect.left || 0;
        var y = offsetY || clientY && clientY - roundRect.top || 0;
        _this.mouseCoordinate = {
          x: Entry.Utils.toFixed((x / roundRect.width - 0.5) * 480),
          y: Entry.Utils.toFixed((y / roundRect.height - 0.5) * -270)
        };
        Entry.dispatchEvent('stageMouseMove');
      };
      canvas.onmousemove = moveFunc;
      canvas.ontouchmove = moveFunc;
      canvas.onmouseout = function () {
        return Entry.dispatchEvent('stageMouseOut');
      };
      var updateObjectFunc = function updateObjectFunc() {
        if (Entry.engine.isState('stop')) {
          Entry.stage.updateObject();
        }
      };
      _addEventListener('updateObject', updateObjectFunc);
      _addEventListener('run', function () {
        return Entry.removeEventListener('updateObject', updateObjectFunc);
      });
      _addEventListener('stop', function () {
        return _addEventListener('updateObject', updateObjectFunc);
      });
      _addEventListener('canvasInputComplete', function () {
        try {
          var inputValue = _this.inputField.value();
          _this.hideInputField();
          if (inputValue) {
            (function (c) {
              c.setInputValue(inputValue);
              c.inputValue.complete = true;
            })(Entry.container);
          }
        } catch (exception) {}
      });
      this.initWall();
      this.initVideoContainer();
      this.render();
      this.dropper = _extension["default"].getExtension('Dropper');
    }
  }, {
    key: "update",
    value:
    /**
     * redraw canvas
     */
    function update() {
      if (Entry.type === 'invisible') {
        return;
      }
      if (!Entry.requestUpdate) {
        Entry.requestUpdate = false;
        return;
      }
      this.updateForce();
      if (Entry.engine.isState('stop') && this.objectUpdated) {
        this.objectUpdated = false;
      }
      var inputField = this.inputField;
      if (inputField && !inputField._isHidden) {
        inputField.render();
      }
      if (Entry.requestUpdateTwice) {
        Entry.requestUpdateTwice = false;
      } else {
        Entry.requestUpdate = false;
      }
    }
  }, {
    key: "updateForce",
    value: function updateForce() {
      this._app && this._app.render();
    }

    /**
     * add object entity on canvas
     * @param {Entry.EntryObject} object
     */
  }, {
    key: "loadObject",
    value: function loadObject(_ref2) {
      var object = _ref2.entity.object,
        scene = _ref2.scene;
      this.getObjectContainerByScene(scene).addChild(object);
      Entry.requestUpdate = true;
    }

    /**
     * add entity directly on canvas
     * This is use for cloned entity
     * @param {Entry.EntityObject} entity
     */
  }, {
    key: "loadEntity",
    value: function loadEntity(_ref3, index) {
      var parent = _ref3.parent,
        object = _ref3.object;
      var objContainer = Entry.stage.getObjectContainerByScene(parent.scene);
      if (index > -1) {
        objContainer.addChildAt(object, index);
      } else {
        objContainer.addChild(object);
      }
      Entry.requestUpdate = true;
    }

    /**
     * Remove entity directly on canvas
     * @param {Entry.EntityObject} entity
     */
  }, {
    key: "unloadEntity",
    value: function unloadEntity(_ref4) {
      var parent = _ref4.parent,
        object = _ref4.object;
      Entry.stage.getObjectContainerByScene(parent.scene).removeChild(object);
      Entry.requestUpdate = true;
    }

    /**
     * add variable view on canvas
     * @param {Entry.Variable} object
     */
  }, {
    key: "loadVariable",
    value: function loadVariable(_ref5) {
      var view_ = _ref5.view_,
        id = _ref5.id;
      this.variables[id] = view_;
      this.variableContainer.addChild(view_);
      Entry.requestUpdate = true;
    }

    /**
     * remove variable view on canvas
     * @param {Entry.Variable} object
     */
  }, {
    key: "removeVariable",
    value: function removeVariable(_ref6) {
      var view_ = _ref6.view_;
      this.variableContainer.removeChild(view_);
      Entry.requestUpdate = true;
    }

    /**
     * add dialog on canvas
     * @param {Entry.Dialog} dialog
     */
  }, {
    key: "loadDialog",
    value: function loadDialog(_ref7) {
      var object = _ref7.object;
      this.dialogContainer.addChild(object);
    }

    /**
     * Remove entity directly on canvas
     * @param {Entry.Dialog} dialog
     */
  }, {
    key: "unloadDialog",
    value: function unloadDialog(_ref8) {
      var object = _ref8.object;
      this.dialogContainer.removeChild(object);
    }
  }, {
    key: "setEntityIndex",
    value: function setEntityIndex(_ref9, index) {
      var object = _ref9.object;
      if (index === -1) {
        return;
      }
      var selectedObjectContainer = Entry.stage.selectedObjectContainer;
      var currentIndex = selectedObjectContainer.getChildIndex(object);
      if (currentIndex === -1 || currentIndex === index) {
        return;
      }
      selectedObjectContainer.setChildIndex(object, index);
      Entry.requestUpdate = true;
    }

    /**
     * sort Z index of objects
     */
  }, {
    key: "sortZorder",
    value: function sortZorder() {
      var objects = Entry.container.getCurrentObjects().slice();
      var length = objects.length;
      var container = this.selectedObjectContainer;
      var index = 0;
      for (var i = length - 1; i >= 0; i--) {
        var object = objects[i].entity.object;
        container.setChildIndex(object, index++);
      }
      if (container) {
        container.children.length = length;
      }
      Entry.requestUpdate = true;
    }

    /**
     * sort Z index of objects while running
     */
  }, {
    key: "sortZorderRun",
    value: function sortZorderRun() {
      Entry.requestUpdate = true;
    }

    /**
     * Initialize coordinate on canvas. It is toggle by Engine.
     */
  }, {
    key: "initCoordinator",
    value: function initCoordinator() {
      var tex = _GEHelper.GEHelper.newSpriteWithCallback("".concat(Entry.mediaFilePath, "workspace_coordinate.png"));
      this.coordinator = (0, _extends2["default"])(tex, {
        scaleX: 0.5,
        scaleY: 0.5,
        x: -240,
        y: -135,
        visible: false
      });
      if (!_GEHelper.GEHelper.isWebGL) {
        this.coordinator.tickEnabled = false;
      }
      this.canvas.addChild(this.coordinator);
    }

    /**
     * Toggle coordinator
     */
  }, {
    key: "toggleCoordinator",
    value: function toggleCoordinator() {
      this.coordinator.visible = !this.coordinator.visible;
      Entry.requestUpdate = true;
    }

    /**
     * Select handle object
     * @param {?Entry.EntryObject} object
     */
  }, {
    key: "selectObject",
    value: function selectObject(object) {
      //todo
      if (!object) {
        this.selectedObject = null;
      } else {
        this.selectedObject = object;
      }
      this.updateObject();
    }

    /**
     * Initialize handle. Handle is use for transform object on canvas.
     */
  }, {
    key: "initHandle",
    value: function initHandle() {
      this.handle = new _GEHandle.GEHandle(this.canvas).setChangeListener(this, this.updateHandle).setEditStartListener(this, this.startEdit).setEditEndListener(this, this.endEdit);
    }

    /**
     * Update handle object to modified object
     * object -> handle
     */
  }, {
    key: "updateObject",
    value: function updateObject() {
      if (Entry.type === 'invisible' || Entry.type === 'playground') {
        return;
      }
      Entry.requestUpdate = true;
      this.handle.setDraggable(true);
      if (this.editEntity) {
        return;
      }
      var object = this.selectedObject;
      if (object) {
        if (object.objectType == 'textBox') {
          this.handle.toggleCenter(false);
        } else {
          this.handle.toggleCenter(true);
        }
        var rotateMethod = object.getRotateMethod();
        if (rotateMethod == 'free') {
          this.handle.toggleRotation(true);
          this.handle.toggleDirection(true);
        } else if (rotateMethod == 'vertical') {
          this.handle.toggleRotation(false);
          this.handle.toggleDirection(true);
        } else {
          this.handle.toggleRotation(false);
          this.handle.toggleDirection(true);
        }
        if (object.getLock()) {
          this.handle.toggleRotation(false);
          this.handle.toggleDirection(false);
          this.handle.toggleResize(false);
          this.handle.toggleCenter(false);
          this.handle.setDraggable(false);
        } else {
          this.handle.toggleResize(true);
        }
        this.handle.setVisible(Entry.objectEditable);
        var entity = object.entity;
        this.handle.setWidth(entity.getScaleX() * entity.getWidth());
        this.handle.setHeight(entity.getScaleY() * entity.getHeight());
        var regX;
        var regY;
        if (entity.type == 'textBox') {
          // maybe 0.
          if (entity.getLineBreak()) {
            regX = entity.regX * entity.scaleX;
            regY = -entity.regY * entity.scaleY;
          } else {
            var fontAlign = entity.getTextAlign();
            regY = -entity.regY * entity.scaleY;
            switch (fontAlign) {
              case Entry.TEXT_ALIGN_LEFT:
                regX = -entity.getWidth() / 2 * entity.scaleX;
                break;
              case Entry.TEXT_ALIGN_CENTER:
                regX = entity.regX * entity.scaleX;
                break;
              case Entry.TEXT_ALIGN_RIGHT:
                regX = entity.getWidth() / 2 * entity.scaleX;
                break;
            }
          }
        } else {
          regX = (entity.regX - entity.width / 2) * entity.scaleX;
          regY = (entity.height / 2 - entity.regY) * entity.scaleY;
        }
        var rotation = entity.getRotation() / 180 * Math.PI;
        this.handle.setX(entity.getX() - regX * Math.cos(rotation) - regY * Math.sin(rotation));
        this.handle.setY(-entity.getY() - regX * Math.sin(rotation) + regY * Math.cos(rotation));
        this.handle.setRegX((entity.regX - entity.width / 2) * entity.scaleX);
        this.handle.setRegY((entity.regY - entity.height / 2) * entity.scaleY);
        this.handle.setRotation(entity.getRotation());
        this.handle.setDirection(entity.getDirection());
        this.objectUpdated = true;
        this.handle.setVisible(Entry.objectEditable && object.entity.getVisible());
        if (object.entity.getVisible()) {
          this.handle.render();
        }
      } else {
        this.handle.setVisible(false);
      }
      //this.toggleHandleEditable(!object.getLock());
    }

    // handle -> object
  }, {
    key: "updateHandle",
    value: function updateHandle() {
      this.editEntity = true;
      var handle = this.handle;
      var entity = this.selectedObject.entity;
      if (entity.lineBreak) {
        entity.setHeight(handle.height / entity.getScaleY());
        entity.setWidth(handle.width / entity.getScaleX());
      } else {
        if (entity.width !== 0) {
          var scaleX = Math.abs(handle.width / entity.width);
          if (entity.flip) {
            scaleX *= -1;
          }
          entity.setScaleX(scaleX);
        }
        if (entity.height !== 0) {
          entity.setScaleY(handle.height / entity.height);
        }
      }
      var direction = handle.rotation / 180 * Math.PI;
      if (entity.type == 'textBox') {
        entity.syncFont();
        var newRegX = handle.regX / entity.scaleX;
        var newRegY = handle.regY / entity.scaleY;
        if (entity.getLineBreak()) {
          entity.setX(handle.x);
          entity.setY(-handle.y);
        } else {
          switch (entity.getTextAlign()) {
            case Entry.TEXT_ALIGN_LEFT:
              entity.setX(handle.x - handle.width / 2 * Math.cos(direction));
              entity.setY(-handle.y + handle.width / 2 * Math.sin(direction));
              break;
            case Entry.TEXT_ALIGN_CENTER:
              entity.setX(handle.x);
              entity.setY(-handle.y);
              break;
            case Entry.TEXT_ALIGN_RIGHT:
              entity.setX(handle.x + handle.width / 2 * Math.cos(direction));
              entity.setY(-handle.y - handle.width / 2 * Math.sin(direction));
              break;
          }
        }
      } else {
        var newRegX = entity.width / 2 + handle.regX / entity.scaleX;
        entity.setX(handle.x + handle.regX * Math.cos(direction) - handle.regY * Math.sin(direction));
        entity.setRegX(newRegX);
        var newRegY = entity.height / 2 + handle.regY / entity.scaleY;
        entity.setY(-handle.y - handle.regX * Math.sin(direction) - handle.regY * Math.cos(direction));
        entity.setRegY(newRegY);
      }
      entity.setDirection(handle.direction);
      entity.setRotation(handle.rotation);
      this.editEntity = false;
    }
  }, {
    key: "startEdit",
    value: function startEdit() {
      var _ref0 = this.selectedObject || {},
        entity = _ref0.entity;
      _.result(entity, 'initCommand');
    }
  }, {
    key: "endEdit",
    value: function endEdit() {
      var _ref1 = this.selectedObject || {},
        entity = _ref1.entity;
      _.result(entity, 'checkCommand');
    }
  }, {
    key: "initWall",
    value: function initWall() {
      var wall = _GEHelper.GEHelper.newContainer('wall');
      wall.mouseEnabled = false;
      var tex = _GEHelper.GEHelper.newWallTexture("".concat(Entry.mediaFilePath, "media/bound.png"));
      var newSide = function newSide(x, y, sx, sy) {
        var sp = _GEHelper.GEHelper.newWallSprite(tex);
        sp.x = x;
        sp.y = y;
        sx ? sp.scaleX = sx : 0;
        sy ? sp.scaleY = sy : 0;
        wall.addChild(sp);
        return sp;
      };
      wall.up = newSide(-240, -135 - 30, 480 / 30, 0);
      wall.down = newSide(-240, 135, 480 / 30, 0);
      wall.right = newSide(240, -135, 0, 270 / 30);
      wall.left = newSide(-240 - 30, -135, 0, 270 / 30);
      this.canvas.addChild(wall);
      this.wall = wall;
    }
  }, {
    key: "initVideoContainer",
    value: function initVideoContainer() {
      this.videoContainer = _GEHelper.GEHelper.getNewContainer();
      this.canvas.addChildAt(this.videoContainer, 2);
      this.overlayContainer = _GEHelper.GEHelper.getNewContainer();
      this.canvas.addChildAt(this.overlayContainer, 3);
    }
  }, {
    key: "getCanvasElement",
    value: function getCanvasElement(id) {
      var canvas = document.getElementById(id);
      if (!canvas) {
        canvas = window.top.document.getElementById(id);
      }
      return canvas;
    }

    /**
     * show inputfield from the canvas
     */
  }, {
    key: "showInputField",
    value: function showInputField() {
      var THIS = this;
      var isWebGL = _GEHelper.GEHelper.isWebGL;
      _GEHelper.GEHelper.disableTickByEngine();
      if (!this.inputField) {
        this.inputField = _createInputField();
        this.inputSubmitButton = _createSubmitButton();
      }
      this.inputField.value('');
      if (isWebGL) {
        this.canvas.addChild(this.inputField.getPixiView());
      }
      this.inputField.show();
      this.canvas.addChild(this.inputSubmitButton);
      Entry.requestUpdateTwice = true;
      function _createInputField() {
        var posX = 15;
        var posY = 275;
        var isWebGL = _GEHelper.GEHelper.isWebGL;
        var classRef = isWebGL ? window.PIXICanvasInput : CanvasInput;
        var inputField = new classRef({
          canvas: THIS.getCanvasElement('entryCanvas'),
          fontSize: 20,
          fontFamily: EntryStatic.fontFamily || "NanumGothic, 'Nanum Gothic'",
          fontColor: '#2c313d',
          width: 520,
          height: 24,
          padding: 13,
          borderWidth: 2,
          borderColor: '#e2e2e2',
          borderRadius: 10,
          boxShadow: 'none',
          innerShadow: 'none',
          x: posX,
          y: posY,
          readonly: false,
          topPosition: true,
          onsubmit: function onsubmit() {
            Entry.dispatchEvent('canvasInputComplete');
          }
        });
        if (isWebGL) {
          var canvas = THIS.canvas;
          var globalScale = canvas.scale.x;
          var textView = inputField.getPixiView();
          textView.scale.set(1 / globalScale);
          textView.position.set(posX / globalScale - canvas.x / globalScale, posY / globalScale - canvas.y / globalScale);
        }
        return inputField;
      } //_createInputField

      function _createSubmitButton() {
        var _ref10 = EntryStatic.images || {},
          confirm_button = _ref10.confirm_button;
        var path = confirm_button || "".concat(Entry.mediaFilePath, "stage/submit.png");
        var inputSubmitButton = _GEHelper.GEHelper.newSpriteWithCallback(path, function () {
          Entry.requestUpdate = true;
        });
        inputSubmitButton.mouseEnabled = true;
        inputSubmitButton.x = 190;
        inputSubmitButton.y = 71.5;
        inputSubmitButton.scaleX = 0.84;
        inputSubmitButton.scaleY = 0.84;
        inputSubmitButton.cursor = 'pointer';
        var eventType = isWebGL ? 'pointerdown' : 'mousedown';
        inputSubmitButton.on(eventType, function () {
          if (!THIS.inputField._readonly) {
            Entry.dispatchEvent('canvasInputComplete');
          }
        });
        return inputSubmitButton;
      } //_createSubmitButton
    }

    /**
     * remove inputfield from the canvas
     */
  }, {
    key: "hideInputField",
    value: function hideInputField() {
      if (!this.inputField) {
        return;
      }
      _GEHelper.GEHelper.tickByEngine();
      if (_GEHelper.GEHelper.isWebGL) {
        this.canvas.removeChild(this.inputField.getPixiView());
      }
      this.inputField.value('');
      this.inputField.hide();
      this.canvas.removeChild(this.inputSubmitButton);
      Entry.requestUpdate = true;
    }

    /**
     * init object containers
     */
  }, {
    key: "initObjectContainers",
    value: function initObjectContainers() {
      var scenes = Entry.scene.scenes_;
      if (!_.isEmpty(scenes)) {
        for (var i = 0; i < scenes.length; i++) {
          this.objectContainers[i] = this.createObjectContainer(scenes[i]);
        }
        this.selectedObjectContainer = this.objectContainers[0];
      } else {
        var obj = this.createObjectContainer(Entry.scene.selectedScene);
        this.objectContainers.push(obj);
        this.selectedObjectContainer = obj;
      }
      if (Entry.type !== 'invisible' && Entry.type !== 'playground') {
        this.canvas.addChild(this.selectedObjectContainer);
      }
      this.selectObjectContainer(Entry.scene.selectedScene);
    }

    /**
     * select object container by scene
     * @param {Entry.Scene} scene
     */
  }, {
    key: "selectObjectContainer",
    value: function selectObjectContainer(scene) {
      var containers = this.objectContainers;
      var canvas = this.canvas;
      if (_.isEmpty(canvas) || _.isEmpty(containers)) {
        return;
      }
      _GEHelper.GEHelper.resManager.activateScene(scene && scene.id);
      var newContainer = this.getObjectContainerByScene(scene);
      containers.forEach(canvas.removeChild.bind(canvas));
      this.selectedObjectContainer = newContainer;
      canvas.addChildAt(newContainer, 4);
    }

    /**
     * init object containers
     */
  }, {
    key: "createObjectContainer",
    value: function createObjectContainer(scene) {
      return (0, _extends2["default"])(_GEHelper.GEHelper.newContainer('[Stage] SceneContainer'), {
        scene: scene
      });
    }

    /**
     * remove object container
     * @param {scene model} scene
     */
  }, {
    key: "removeObjectContainer",
    value: function removeObjectContainer(scene) {
      var containers = this.objectContainers;
      var objContainer = this.getObjectContainerByScene(scene);
      var canvas = this.canvas;
      if (canvas) {
        canvas.removeChild(objContainer);
      }
      _GEHelper.GEHelper.resManager.removeScene(scene.id);
      containers.splice(containers.indexOf(objContainer), 1);
    }

    /**
     * get object container
     * @param {scene model} scene
     */
  }, {
    key: "getObjectContainerByScene",
    value: function getObjectContainerByScene(_ref11) {
      var id = _ref11.id;
      return _.find(this.objectContainers, function () {
        var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          scene = _ref12.scene;
        return scene.id === id;
      });
    }
  }, {
    key: "moveSprite",
    value: function moveSprite(_ref13) {
      var shiftKey = _ref13.shiftKey,
        keyCode = _ref13.keyCode;
      var selectedObject = this.selectedObject;
      if (!selectedObject || !Entry.stage.focused || selectedObject.getLock()) {
        return;
      }
      var distance = shiftKey ? 1 : 5;
      var entity = selectedObject.entity;
      switch (keyCode) {
        case 38:
          //up
          entity.setY(entity.getY() + distance);
          break;
        case 40:
          //down
          entity.setY(entity.getY() - distance);
          break;
        case 37:
          //left
          entity.setX(entity.getX() - distance);
          break;
        case 39:
          //right
          entity.setX(entity.getX() + distance);
          break;
      }
      this.updateObject();
    }
  }, {
    key: "getBoundRect",
    value: function getBoundRect(e) {
      if (!this._boundRect) {
        return this.updateBoundRect();
      }
      return this._boundRect;
    }
  }, {
    key: "updateBoundRect",
    value: function updateBoundRect(e) {
      return this._boundRect = this.canvas.canvas.getBoundingClientRect();
    }
  }, {
    key: "getDom",
    value: function getDom(query) {
      var key = query.shift();
      if (key === 'canvas') {
        return this.canvas.canvas;
      }
    }
  }, {
    key: "setEntitySelectable",
    value: function setEntitySelectable(value) {
      this._entitySelectable = value;
    }
  }, {
    key: "isEntitySelectable",
    value: function isEntitySelectable() {
      return Entry.engine.isState('stop') && this._entitySelectable && !this.dropper.isShow;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var destroyOption;
      if (_GEHelper.GEHelper.isWebGL) {
        var _PIXIAtlasManager$cle;
        destroyOption = {
          children: true,
          texture: false,
          baseTexture: false
        };
        this.objectContainers.forEach(function (c) {
          return c.destroy(destroyOption);
        });
        //this.handle.destroy(); // 추상화 아직 안됨.
        _PIXIAtlasManager.PIXIAtlasManager === null || _PIXIAtlasManager.PIXIAtlasManager === void 0 || (_PIXIAtlasManager$cle = _PIXIAtlasManager.PIXIAtlasManager.clearProject) === null || _PIXIAtlasManager$cle === void 0 || _PIXIAtlasManager$cle.call(_PIXIAtlasManager.PIXIAtlasManager);
      } else {
        //do nothing
      }
      if (this._app) {
        this._app.destroy(destroyOption);
        this._app = null;
      }
      this.handle = null;
      this.objectContainers = null;
    }
  }]);
}();